import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../../store/action/post'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { renderFormField, renderTextAreaField } from '../../../utils/reduxField'
import * as _ from 'lodash'
import Select from 'react-select'
import AddContentCreator from '../../../components/posts/add-content-creator'
import CreatorItem from './creator-item/creator-item'
class DimensionTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dimensions: props.post.currentPost.dimensions || []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { post: { currentPost: nextCurrentPost } } = nextProps; 
        let { dimensions } = this.state;
        if(dimensions != nextCurrentPost.dimensions){
            this.setState({dimensions: nextCurrentPost.dimensions});
        }
    }
  
    render() {
        const { layoutName, checkClass, post: { currentPost } } = this.props;
        let { dimensions } = this.state;
        return (
            <div className={(layoutName !== 'layout-pc' ? 'row card' : '')}>
                {
                    layoutName !== 'layout-pc' &&
                    <div className={"card-header col-12 " + (checkClass)}>
                        <h4 className="card-title">Dimension</h4>
                        <div className="card-tools">
                            <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                <i className="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                }

                <div className="card-body col-12">
                    <CreatorItem creatable={true} functioncreate="createNewDimension" functioncall="getListDimension" newapi="/dimensions" valueinstore="listDimensions" posttype="dimensions"
                        type="dimensions" selectedValue={dimensions} isClearable={true} label="Chọn dimension cho bài viết" placeholder="Chọn dimension cho bài viết" ismulti={true} />
                </div>


            </div>


        )
    }

};

export default connect(store => {
    return {
        post: store.post,
        config: store.config,
    };
}, dispatch => {
    return {
        setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    }
})(DimensionTab)
